import * as cookie from 'cookie'

import { Monitoring } from '@grammarly/telemetry'

import { getConfig } from '../../config'

const cookieDomain = getConfig().domains.cookie

export enum Cookie {
  CsrfToken = 'csrf-token',
  GoInstallationSource = 'sh_installation_flow_source',
  AtcVisited = 'superhuman_atc_visited',
  WebDevice = 'web-device',
  ShMailExtensionInstalled = 'sh_mail_extension_installed',
}

const logServerSideWarning = (cookieName: string, action: 'parse' | 'set') => {
  const stackTraceError = new Error(`Cannot ${action} cookie ${cookieName} at the server-side`)
  Monitoring.Logging.getLogger('cookie.interception').warn(
    `Cannot ${action} cookie ${action === 'set' ? 'to' : 'from'} document at the server-side`,
    {
      cookieName,
      stackTrace: stackTraceError.stack,
    },
  )
}

export const getCookie = (name: Cookie): string | undefined => {
  if (!IS_CLIENT_SIDE) {
    logServerSideWarning(name, 'parse')
    return
  }

  return cookie.parse(document.cookie)[name]
}

export const setCookie = (name: Cookie, value: boolean | string, maxAgeSec?: number): void => {
  if (!IS_CLIENT_SIDE) {
    logServerSideWarning(name, 'set')
    return
  }

  // TODO: fix implementation or change lint rule
  // eslint-disable-next-line unicorn/no-document-cookie
  document.cookie = cookie.serialize(name, value.toString(), {
    expires: maxAgeSec ? new Date(Date.now() + maxAgeSec * 1000) : undefined,
    path: '/',
    domain: cookieDomain,
  })
}

export const deleteCookie = (name: string | Cookie) => {
  // TODO: fix implementation or change lint rule
  // eslint-disable-next-line unicorn/no-document-cookie
  document.cookie = `${name}=;path=/;domain=${cookieDomain};expires=Thu, 01 Jan 1970 00:00:01 GMT`
}
